<template>
	<div class="page__logobar">
			<div>
				<a href="http://www.barnatasa.com/">
					<img src="../assets/img/bt_logo_tr.png" alt="BARNA-TASA" style="width: auto; height: 4rem;"/>
				</a>
			</div>
			<div>
				<a href="http://www.bde.es/">
					<img src="../assets/img/logo_bde.png" alt="BDE" style="width: auto; height: 6rem;"/>
				</a>
			</div>
		<!--
			<div>
				<a href="http://www.arquitectes.cat/">
					<img src="../assets/img/logo_coac.png" alt="COAC" style="width: auto; height: 3rem;"/>
				</a>
			</div>
			<div>
				<a href="http://www.arquitectesexperts.com/">
					<img src="../assets/img/logo_aepfmc.png" alt="AEPFMC" style="width: auto; height: 5rem;"/>
				</a>
			</div>
			-->
	</div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'

    import router from '../router'
    import { localStorageMixin } from '../mixins'

    export default {
        name: 'logo-bar',

        head: {
            title: {
                inner: 'Barnatasa'
            }
        }

    }
</script>


// WEBPACK FOOTER //
// LogoBar.vue?24bbb8f2